import {
  Component,
  Inject,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import {
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import {
  FreightSerialMatch,
  FreightSerialDialogData
} from '../freight.models';  

@Component({
  selector: 'app-freight-serial-select-dialog',
  templateUrl: './freight-serial-select-dialog.component.html'
})
export class FreightSerialSelectDialogComponent implements AfterViewInit {
  @ViewChild('selList', { static: false }) selList?: MatSelectionList;

  constructor(
    public dialogRef: MatDialogRef<FreightSerialSelectDialogComponent, FreightSerialMatch[]>,
    @Inject(MAT_DIALOG_DATA) public data: FreightSerialDialogData
  ) {}

  ngAfterViewInit(): void {
    // Guarded subscription so we don't explode when the ViewChild isn't available yet.
    this.selList?.selectionChange.subscribe(() => {
      const selected = this.selList?.selectedOptions?.selected ?? [];
      if (this.data.maxSelectable && selected.length > this.data.maxSelectable) {
        // example: keep only the most recently toggled item(s)
        selected[selected.length - 1].toggle();
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    const selected =
      this.selList?.selectedOptions?.selected?.map(o => o.value as FreightSerialMatch) ?? [];
    this.dialogRef.close(selected);
  }
}
